module.exports = __webpack_public_path__ + "static/img/truck.3ff6155c.png";